import { Injectable } from '@angular/core';
import { AuthTokenService } from './auth-token.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ExpiryStages } from '../common/constants.lib';
import { LoggerService } from '../shared/logger.service';

@Injectable({
  providedIn: 'root'
})
export class TimeoutService {

  private timerHandle: ReturnType<typeof setInterval> | undefined;

  private _expiresIn: BehaviorSubject<number> = new BehaviorSubject<number>(60);
  get expiresIn$() {
    return this._expiresIn.asObservable();
  }
  get expiresIn() {
    return this._expiresIn.getValue();
  }
  set expiresIn(val: number) {
    this._expiresIn.next(val);
  }

  private _prevExpiresIn: number = -2;

  private _expiryStage = new BehaviorSubject<ExpiryStages>(ExpiryStages.Safe);
  get expiryStage$() {
    return this._expiryStage.asObservable();
  }
  get expiryStage() {
    return this._expiryStage.getValue();
  }
  set expiryStage(val: ExpiryStages) {
    this._expiryStage.next(val);
  }

  constructor(
    private logger: LoggerService,
    private authTokenService: AuthTokenService,
    private router: Router
  ) {
    // this.startCountdown();
  }

  startCountdown() {
    this.logger.debug(`startCountdown...`);
    if (this.timerHandle) {
      this.stopCountdown();
    }
    if (!this.timerHandle) {
      this.doCheck();
      this.timerHandle = setInterval(() => this.doCheck(), 5000)
    }
  }

  stopCountdown() {
    this.logger.debug(`stopCountdown...`);
    if (this.timerHandle) {
      clearInterval(this.timerHandle);
      this.timerHandle = undefined;
    }
  }

  private doCheck() {
    if (!!this._prevExpiresIn && this._prevExpiresIn >= -1 && this.expiresIn < 0) {
      this.logger.debug(`doCheck:making this change`, this.expiresIn, this._prevExpiresIn, this.router.url);
      this.stopCountdown();
      this.authTokenService.loggedIn = false;
      if (this.router.url !== '/login') {
        this.router.navigate(['/home-logged-out']);
      }
    }
    this._prevExpiresIn = this.expiresIn;
    this.expiresIn = this.authTokenService.expiresIn();
    this.logger.debug(`doCheck...`, this.expiresIn, this._prevExpiresIn);
    if (this.expiresIn >= 300) {
      this.expiryStage = ExpiryStages.Safe;
    } else if (this.expiresIn > 30 && this.expiresIn < 300) {
      this.expiryStage = ExpiryStages.Warning;
    } else if (this.expiresIn > 0 && this.expiresIn <= 30) {
      this.expiryStage = ExpiryStages.Imminent;
    } else {
      this.expiryStage = ExpiryStages.Expired;
    }
  }
}
